// ── Date / time display formatters ──────────────────────────────────────────
// Single source of truth for all date rendering across the UI.
// To change locale or format, edit the constants below.
//
// Outputs:
//   fmtDate     → "23 Jul 2026"
//   fmtDateTime → "23 Jul 2026, 4:45 PM"
//   fmtTime     → "4:45 PM"
//   null / undefined / '' / invalid → "—"
//
// Timezone: always the user's local timezone (browser default).

const DATE_LOCALE = 'en-GB';   // day-month-year order, e.g. "23 Jul 2026"
const TIME_LOCALE = 'en-US';   // uppercase AM/PM, e.g. "4:45 PM"

const DATE_OPTS = { day: 'numeric', month: 'short', year: 'numeric' };
const TIME_OPTS = { hour: 'numeric', minute: '2-digit', hour12: true };

function parse(value) {
  if (!value && value !== 0) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function fmtDate(value) {
  const d = parse(value);
  return d ? d.toLocaleDateString(DATE_LOCALE, DATE_OPTS) : '—';
}

export function fmtDateTime(value) {
  const d = parse(value);
  if (!d) return '—';
  const date = d.toLocaleDateString(DATE_LOCALE, DATE_OPTS);
  const time = d.toLocaleTimeString(TIME_LOCALE, TIME_OPTS);
  return `${date}, ${time}`;
}

export function fmtTime(value) {
  const d = parse(value);
  return d ? d.toLocaleTimeString(TIME_LOCALE, TIME_OPTS) : '—';
}
